module.exports = __webpack_public_path__ + "assets/adpoly-facility-gates-bulk-upload-template.db582813.xlsx";